export const UnitActivityAddinName = 'UnitActivity';
